import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { OrgHomeScreenProps } from "../OrgHomeNavigation";
import { WorkspaceComplianceRoutines } from "./WorkspaceComplianceRoutines/WorkspaceComplianceRoutines";
import {
  WorkspaceRoutinesStackScreenProps,
  WorkspaceRoutinesTab,
  WorskpaceRoutinesStack,
} from "./WorkspaceRoutinesNavigation";
import { WorkspaceRoutineTemplatesScreen } from "./WorkspaceRoutineTemplates/WorkspaceRoutineTemplates";
import { WorkspaceComlianceRoutinesCreateButton } from "./WorkspaceComplianceRoutinesCreateButton";
import { WorkspaceRoutinesOccasionScreen } from "./WorkspaceRoutineOccasion/WorkspaceRoutinesOccasionScreen";
import { useTheme, Box } from "arkh";
import { WorkspaceRoutineTemplateCreateButton } from "./WorkspaceRoutineTemplateCreateButton";
import { OrgButton } from "../OrgButton";
import { WorkspaceArchivedRoutines } from "./WorkspaceArchivedRoutines/WorkspaceArchivedRoutines";
import { WorkspaceRoutineTemplateDetail } from "./WorkspaceRoutineTemplates/WorkspaceRoutineTemplateDetail";
import { WorkspaceRoutineTemplateStoreDetail } from "./WorkspaceRoutineTemplates/WorkspaceRoutineTemplateStoreDetail";

function WorkspaceRoutinesTabNavigator(
  props: WorkspaceRoutinesStackScreenProps<"WorkspaceRoutinesTab">
) {
  const intl_tokens = useIntlTokens();

  return (
    <WorkspaceRoutinesTab.Navigator
      screenOptions={{
        headerShown: false,
      }}
      headerRight={(selectedIndex) => {
        if (selectedIndex === 0) {
          return (
            <Box style={{ flexDirection: "row", alignItems: "center" }}>
              <OrgButton
                backgroundColor="transparent"
                icon="archive"
                tintColor="text-secondary"
                title={intl_tokens.ShowArchived}
                onPress={() => {
                  props.navigation.navigate("WorkspaceArchivedRoutines", {});
                }}
              />
              <Box spaceRight="medium" />
              <WorkspaceComlianceRoutinesCreateButton
                openRoutineEdit={(params) =>
                  props.navigation.navigate("RoutineEdit", {
                    ...params,
                  })
                }
              />
            </Box>
          );
        }
        if (selectedIndex === 1) {
          return (
            <WorkspaceRoutineTemplateCreateButton
              openRoutineEdit={(params) =>
                props.navigation.navigate("RoutineEdit", {
                  ...params,
                })
              }
            />
          );
        }
        return null;
      }}
      title={intl_tokens.Checklists}
      initialRouteName="WorkspaceComplianceRoutines"
    >
      <WorkspaceRoutinesTab.Screen
        component={WorkspaceComplianceRoutines}
        name="WorkspaceComplianceRoutines"
        options={{
          title: intl_tokens.CentralisedChecklists,
        }}
      />
      <WorkspaceRoutinesTab.Screen
        component={WorkspaceRoutineTemplatesScreen}
        name="WorkspaceRoutinesTemplates"
        options={{
          title: intl_tokens.RoutineLibrary,
        }}
      />
    </WorkspaceRoutinesTab.Navigator>
  );
}

export function WorkspaceRoutines(props: {
  navigation: OrgHomeScreenProps<"WorkspaceRoutines">;
}) {
  const theme = useTheme();

  return (
    <WorskpaceRoutinesStack.Navigator
      screenOptions={{
        contentStyle: {
          backgroundColor: theme["surface-background-light"],
        },
        headerShown: false,
      }}
    >
      <WorskpaceRoutinesStack.Screen
        component={WorkspaceRoutinesTabNavigator}
        name="WorkspaceRoutinesTab"
      />
      <WorskpaceRoutinesStack.Screen
        component={WorkspaceRoutinesOccasionScreen}
        name="WorkspaceRoutineOccasion"
      />
      <WorskpaceRoutinesStack.Screen
        component={WorkspaceRoutineTemplateDetail}
        name="WorkspaceRoutineTemplateDetail"
      />
      <WorskpaceRoutinesStack.Screen
        component={WorkspaceRoutineTemplateStoreDetail}
        name="WorkspaceRoutineTemplateStoreDetail"
      />
      <WorskpaceRoutinesStack.Screen
        component={WorkspaceArchivedRoutines}
        name="WorkspaceArchivedRoutines"
      />
    </WorskpaceRoutinesStack.Navigator>
  );
}
